import { Injectable } from '@angular/core';
import { ProjectStatus } from '../../shared/models/project-status.enum';

@Injectable({
  providedIn: 'root',
})
export class StatusUpdateService {
  constructor() {}

  /**
   * Checks if the status should change based on the given item data.
   * @param item - The NFT data item to check.
   * @returns The new status if it has changed, otherwise null.
   */
  checkStatusChange(item: any): string | null {
    if (!item) return null;

    const targetAmount = item.amountToSell * (item.priceToken / 100);
    const eurosSold = item.amountSold * (item.priceToken / 100);

    let percentageSoldNumber = 0;
    let percentageSold = '0.00';

    if (item.amountToSell && item.priceToken) {
      const result =
        (eurosSold * 100) / (item.amountToSell * (item.priceToken / 100));
      percentageSoldNumber = result;
      percentageSold = result.toFixed(2);
    }

    // Add Sold condition
    if (percentageSoldNumber >= 100) {
      return ProjectStatus.FUNDED;
    }

    const managing = item?.managingReinvestments ?? item?.managingInvestments;
    if (managing) {
      return ProjectStatus.MANAGING_REINVESTMENTS;
    }

    if (
      this.toFloor(item.endOfSale) === 'Tiempo agotado' &&
      eurosSold < targetAmount
    ) {
      return 'Finalizado';
    }

    if (item.blockchain) {
      return 'Activo';
    }

    return null;
  }

    /**
   * Calculates the time remaining until the sale ends or returns 'Tiempo agotado'.
   * @param endOfSale - The timestamp for the end of the sale
   * @returns Remaining time as a string or 'Tiempo agotado'
   */
    private toFloor(num: number): string {
      if (num === undefined || num === null || num === 0) {
        return 'No activo';
      }
  
      const nowTimeStamp: number = Math.floor(Date.now() / 1000);
  
      const secondsDiff = num - nowTimeStamp;
      const minutesDiff = secondsDiff / 60;
      const hoursDiff = minutesDiff / 60;
      const daysDiff = hoursDiff / 24;
  
      if (daysDiff >= 1) {
        return 'Quedan: ' + Math.floor(daysDiff) + ' días';
      }
  
      if (hoursDiff >= 1) {
        return 'Quedan: ' + Math.floor(hoursDiff) + ' horas';
      }
  
      if (minutesDiff >= 1) {
        return 'Quedan: ' + Math.floor(minutesDiff) + ' minutos';
      }
  
      if (secondsDiff >= 1) {
        return 'Quedan: ' + Math.floor(secondsDiff) + ' segundos';
      }
  
      return 'Tiempo agotado';
    }
  /**
   * Determines if the project is currently in the "Gestionando inversiones" state.
   * @param info - Project information
   * @param eurosSold - Amount of euros sold
   * @returns A boolean indicating if the project is managing investments
   */
  private isManagingInvestments(info: any, eurosSold: number): boolean {
    const targetAmount = info.amountToSell * (info.priceToken / 100);
    return (
      info?.proyectStatus === 'Activo' &&
      (info?.managingReinvestments ?? info?.managingInvestments) &&
      eurosSold < targetAmount
    );
  }
}
